// extracted by mini-css-extract-plugin
export default {"tupacGrid":"wl-z","tupacHeader":"xl-z","tupacHeader2":"yl-z","tupacMenu":"zl-z","tupacMenu2":"Al-z","tupacMain":"Bl-z","tupacMain2":"Cl-z"};